import * as React from 'react';
import UHDRSForm from './UHDRS';

const MotorFuncHuntForm = ({ formData, document, viewing = false, editing }: IOwnProps): React.JSX.Element | null =>
  document?._type === 'uhdrsMotorRatingScale' ? (
    <UHDRSForm formData={formData} viewing={viewing} editing={editing} />
  ) : null;

interface IOwnProps {
  formData: IFormData<IDocumentWithTypeV2<'uhdrsMotorRatingScale'>>;
  document?: IDocumentWithTypeV2<'uhdrsMotorRatingScale'>;
  viewing?: boolean;
  editing?: any;
}

export default MotorFuncHuntForm;
